// Shared documentation block renderer - used by the Docs Center and the in-module Help panel.
export const bold = (s) => String(s).split('**').map((part, i) => (i % 2 ? <b key={i}>{part}</b> : part));

export const Block = ({ b, onImg }) => {
  if (b.h) return <h3 className="font-display font-bold text-base mt-6 mb-1.5">{b.h}</h3>;
  if (b.p) return <p className="text-sm text-slate-600 mb-2 leading-relaxed">{bold(b.p)}</p>;
  if (b.list) return <ul className="mb-2">{b.list.map((x, i) => <li key={i} className="text-sm text-slate-600 ms-4 list-disc mb-1 leading-relaxed">{bold(x)}</li>)}</ul>;
  if (b.steps) return <ol className="mb-2">{b.steps.map((x, i) => (
    <li key={i} className="text-sm text-slate-600 mb-1.5 flex gap-2 leading-relaxed">
      <span className="shrink-0 w-5 h-5 rounded-full bg-slate-900 text-white text-[10px] flex items-center justify-center font-bold mt-0.5">{i + 1}</span>
      <span>{bold(x)}</span></li>))}</ol>;
  if (b.code) return <pre className="bg-slate-900 text-slate-100 rounded-md p-3 text-xs overflow-x-auto my-2 whitespace-pre-wrap">{b.code}</pre>;
  if (b.callout) return <div className={`text-sm rounded-md border px-3 py-2 my-3 ${b.tone === 'warn' ? 'border-amber-300 bg-amber-50 text-amber-800' : 'border-sky-200 bg-sky-50 text-sky-800'}`}>{bold(b.callout)}</div>;
  if (b.img) return (
    <figure className="my-4">
      <img src={b.img} alt={b.cap || 'screenshot'} loading="lazy" onClick={() => onImg && onImg(b)}
        className={`rounded-lg border border-slate-200 shadow-sm w-full max-w-2xl transition-colors ${onImg ? 'cursor-zoom-in hover:border-orange-400' : ''}`} />
      {b.cap && <figcaption className="text-xs text-slate-400 mt-1">{b.cap}</figcaption>}
    </figure>);
  if (b.kv) return (
    <div className="border border-slate-200 rounded-lg divide-y divide-slate-100 my-3">
      {b.kv.map(([k, v], i) => (
        <div key={i} className="grid sm:grid-cols-[200px_1fr] gap-1 px-3 py-2">
          <span className="text-sm font-semibold text-slate-800">{k}</span>
          <span className="text-sm text-slate-600">{bold(v)}</span></div>))}
    </div>);
  if (b.table) return (
    <div className="overflow-x-auto my-3 border border-slate-200 rounded-lg">
      <table className="w-full text-sm">
        <thead><tr className="bg-slate-50">{b.table.cols.map((c) => <th key={c} className="text-start px-3 py-2 font-mono-label text-[10px] uppercase text-slate-400">{c}</th>)}</tr></thead>
        <tbody>{b.table.rows.map((r, i) => <tr key={i} className="border-t border-slate-100">{r.map((c, j) => <td key={j} className={`px-3 py-2 ${j === 0 ? 'font-medium text-slate-800' : 'text-slate-600'}`}>{bold(c)}</td>)}</tr>)}</tbody>
      </table>
    </div>);
  return null;
};
